<template>
    <ScrollableVueCard :title="$t('lang.busqueda.SEARCH ADDRESS')" >
    <div style="margin: 10px; margin-top: 20px">
        <blockquote>
            <v-textarea
              rows="2"
              :hide-details="true"
              v-model="address"
              name="input-7-4"
              outlined
              @keydown.enter.exact.prevent
              @keyup.enter.exact="buscar"
              @keydown.enter.shift.exact="newline"
              v-bind:label="$t('lang.busqueda.ADDRESS')"
            ></v-textarea>
        </blockquote>
        <BR/>
        <!--<v-select
            :items="zoomlevels"
            v-model="zoomSelected"
            name="zoomSelected"
            item-text="name"
            v-bind:label="$t('lang.busqueda.ZOOM LEVEL')"
            dense
            outlined
          >
          <template slot='selection' slot-scope='{ item }'>
            {{ $t('lang.busqueda.' + item.name) }}
          </template>
          <template slot='item' slot-scope='{ item }'>
            {{ $t('lang.busqueda.' + item.name) }}
          </template>
          </v-select>-->
        <v-divider></v-divider>
        <v-card-actions>
            <v-btn
            block
            elevation="2"
            text
            @click="buscar()"
            >Buscar</v-btn>
        </v-card-actions>

    </div>
    <v-snackbar v-if="snackbarsuccess" v-model="snackbarsuccess" :bottom= false color="error" :left= false :multi-line= false :right= false :timeout="timeout" :top= true :vertical= true>
        {{ successtext }}
    </v-snackbar>
    </ScrollableVueCard>
    
</template>


<script>
import ScrollableVueCard from '@/components/ScrollableVueCard/ScrollableVueCard.vue'
import Alarma from '@/components/ListaAlarmas/Alarma/Alarma.vue'
import {AlertType, zoomlevels} from '@/views/helpers'
import store from '@/store'

export default {
    name: 'ComponenteAlarmas',
    props:{
        title: String,
        pendientes: Boolean
    },
    components:{
        Alarma,
        ScrollableVueCard
    },
    data: () => ({
        AlertType,
        zoomlevels,
        zoomSelected: zoomlevels[1].value,
        address: '',
        snackbarsuccess: false,
        successtext: '',
        timeout: 2500
    }),
    methods:{
        buscar(){
            if(!this.zoomSelected){
                this.snackbarsuccess = true
                this.successtext = "Nivel de zoom no establecido"
            }
            else if (!this.address){
                this.snackbarsuccess = true
                this.successtext = "Es necesario agregar una dirección válida"
            }
            else{
                this.$emit('search-query', {zoom: this.zoomSelected, query: this.address});
            }
        },
        newline(){
            
        }
    }
}
</script>

<style scoped> 
::v-deep textarea {
  resize: none !important;
  margin-top: 2px !important;
  margin-bottom: 2px !important;
}


</style>